import React from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useTheme } from '../theme';
import { ThemedLayout } from '../layout/ThemedLayout';

export const AuthenticatedLayout = props => {
    const { theme } = useTheme();

    return (
        <ThemeProvider theme={createTheme(theme)}>
            <CssBaseline />
            <ThemedLayout {...props} />
        </ThemeProvider>
    );
};
